import { createClient } from '@supabase/supabase-js';

const EXTERNAL_SUPABASE_URL = 'https://tmjaisdcsjfznazetzta.supabase.co';
const EXTERNAL_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRtamFpc2Rjc2pmem5hemV0enRhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI3MjQ3NzAsImV4cCI6MjA4ODMwMDc3MH0.SPSU7sghmi7IlYLa7X47WXPvcuQGdrlbcWz5soeQs7Y';

export const externalSupabase = createClient(EXTERNAL_SUPABASE_URL, EXTERNAL_SUPABASE_ANON_KEY);
